import { render, staticRenderFns } from "./AscCenteredText.vue?vue&type=template&id=33e549dd&"
import script from "./AscCenteredText.vue?vue&type=script&lang=js&"
export * from "./AscCenteredText.vue?vue&type=script&lang=js&"
import style0 from "./AscCenteredText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports